var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 11.9668C8.51172 11.9668 8.40625 11.918 8.30859 11.8203L3.86719 7.14453C3.82812 7.10547 3.79688 7.0625 3.77344 7.01562C3.75391 6.96875 3.74414 6.91602 3.74414 6.85742C3.74414 6.7832 3.76172 6.71484 3.79688 6.65234C3.83203 6.58984 3.87891 6.54102 3.9375 6.50586C4 6.4707 4.06836 6.45312 4.14258 6.45312C4.25977 6.45312 4.35547 6.49219 4.42969 6.57031L8.88281 11.2461H8.36719L12.8145 6.57031C12.8965 6.49219 12.9922 6.45312 13.1016 6.45312C13.1797 6.45312 13.248 6.4707 13.3066 6.50586C13.3652 6.54102 13.4121 6.58984 13.4473 6.65234C13.4863 6.71484 13.5059 6.7832 13.5059 6.85742C13.5059 6.96289 13.4648 7.05664 13.3828 7.13867L8.94141 11.8203C8.89844 11.8672 8.84961 11.9043 8.79492 11.9316C8.74023 11.9551 8.68359 11.9668 8.625 11.9668Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.09fce21f.svg";
export { ForwardRef as ReactComponent };